import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { ApiResultModel, osnOrderLookupService } from "@WhiteCap/Store/Service/OrderStatusLookupService";

// Load OSN order redirect URL
export interface OrderLookupApiParameter extends ApiParameter {
    orderNumber: string;
    onSuccess?: (redirectUrl: string) => void;
    onError?: (message: string) => void;
}
type HandlerType = CustomApiHandler<OrderLookupApiParameter, ApiResultModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    const result = await osnOrderLookupService(props.apiParameter.orderNumber);
    if (result.successful && result.result) {
        props.apiResult = result.result;
        if (props.apiParameter?.onSuccess) {
            props.apiParameter?.onSuccess(props.apiResult.redirectUrl);
        }
    } else {
        if (props.apiParameter?.onError) {
            props.apiParameter.onError(result.errorMessage);
        }
        return false;
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi];

const getOrderRedirectUrl = createHandlerChainRunner(chain, "GetOrderRedirectUrl");
export default getOrderRedirectUrl;
